import { ShieldCheck } from "lucide-react";
import { FadeUp } from "./Reveal";
import { useI18n } from "@/context/Language";

export const NoteFromMaria = () => {
  const { t } = useI18n();
  const C = t.note;

  return (
    <section id="about" className="relative py-16 sm:py-20 border-t border-border-soft">
      <div className="max-w-3xl mx-auto px-6 sm:px-8 text-center" data-testid="note-from-maria">
        <FadeUp>
          <div className="inline-flex items-center gap-2 text-terracotta">
            <ShieldCheck className="h-4 w-4" />
            <span className="text-xs font-semibold uppercase tracking-[0.2em]">{C.overline}</span>
          </div>
          <p className="mt-5 text-sm leading-relaxed text-ink/70">
            {C.paragraphs[0]}
          </p>
          <p className="mt-3 text-xs text-ink/40">
            <span className="font-semibold text-ink/60">Maria-Katharina Richters</span> · {C.role}
          </p>
        </FadeUp>
      </div>
    </section>
  );
};

export default NoteFromMaria;
